import { render, staticRenderFns } from "./pickup-customer.vue?vue&type=template&id=acf093ae&scoped=true"
import script from "./pickup-customer.vue?vue&type=script&lang=js"
export * from "./pickup-customer.vue?vue&type=script&lang=js"
import style0 from "./pickup-customer.vue?vue&type=style&index=0&id=acf093ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf093ae",
  null
  
)

export default component.exports